import { Link } from "react-router-dom";

// material-ui
import { ButtonBase } from "@mui/material";

import cublogo from "../../../assets/City-Union-Bank-Logo.jpg";

// project imports
import config from "config";
import Logo from "ui-component/Logo";

// ==============================|| MAIN LOGO ||============================== //

const LogoSection = () => (
  // <ButtonBase disableRipple component={Link} to={config.defaultPath}>
  <div component={Link} to="/">
    {/* <Logo /> */}
    <img
      src={cublogo}
      alt="cub logo"
      style={{ display: "block", width: "250px" }}
    />
  </div>
);

export default LogoSection;
